import React, { useState, useEffect } from 'react';
import axios from 'axios';

const FeedbackLogTable = () => {
  const [isModalVisible, setModalVisible] = useState(false);
  const [feedbacks, setFeedbacks] = useState([]);

  const openModal = () => setModalVisible(true);
  const closeModal = () => setModalVisible(false);

  const user = JSON.parse(localStorage.getItem('user'));
  const email = user?.email;

  useEffect(() => {
    const fetchFeedbacks = async () => {
      try {
        if (!email) {
          console.error('Email is missing in localStorage');
          return;
        }

        const response = await axios.get(`https://citi-mobile-app.onrender.com/saleagent/feedbacks/${email}`);
        setFeedbacks(response.data.feedbacks);
      } catch (error) {
        console.error('Failed to fetch feedbacks', error);
      }
    };

    fetchFeedbacks();
  }, [email]);

  return (
    <div className="container mx-auto mt-20 p-4 md:ml-60 max-w-full lg:max-w-[80%]">
      <div className="flex justify-between items-center mb-4">
        <button
          onClick={openModal}
          className="bg-blue-500 text-white px-4 py-2 rounded-lg"
        >
          + Add Feedback
        </button>
      </div>

      <div className="overflow-x-auto bg-white rounded-md p-3 shadow-md">
        <h2 className="text-xl font-semibold mb-4">Feedback & Log Visit Table</h2>
        <table className="min-w-full bg-white rounded-lg text-left">
          <thead>
            <tr className="bg-gray-100 text-gray-600">
              <th className="py-3 px-4 font-semibold">No</th>
              <th className="py-3 px-4 font-semibold">Visit Date</th>
              <th className="py-3 px-4 font-semibold">Outcome</th>
              <th className="py-3 px-4 font-semibold">Strike Rate</th>
              <th className="py-3 px-4 font-semibold">Comments</th>
            </tr>
          </thead>
          <tbody>
            {feedbacks.map((item, index) => (
              <tr key={index} className="border-t">
                <td className="py-2 px-4">{index + 1}</td>
                <td className="py-2 px-4">{item.visitDate}</td>
                <td className="py-2 px-4">{item.visitOutcome}</td>
                <td className="py-2 px-4">{item.strikeRate}</td>
                <td className="py-2 px-4">{item.comment}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modal for Feedback Form */}
      <FeedbackModal isVisible={isModalVisible} onClose={closeModal} />
    </div>
  );
};

// Feedback Modal Component Inside Same File
const FeedbackModal = ({ isVisible, onClose }) => {
  const [visitDate, setVisitDate] = useState('');
  const [visitOutcome, setVisitOutcome] = useState('Successful');
  const [comment, setComment] = useState('');
  const [strikeRate, setStrikeRate] = useState('');
  const [customerName, setcustomerName] = useState('');

  const user = JSON.parse(localStorage.getItem('user'));
  const email = user?.email;

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const feedback = {
        customerName, // assuming this is static
        visitDate,
        visitOutcome,
        comment,
        strikeRate,
        email,
      };

      await axios.post('https://citi-mobile-app.onrender.com/saleagent/feedbacks', feedback);
      onClose(); // Close the modal after submission
    } catch (error) {
      console.error('Failed to submit feedback', error);
    }
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex items-center justify-center">
      <div className="bg-white w-full max-w-lg p-6 rounded-md shadow-lg mx-4">
        <h3 className="text-lg font-semibold mb-4">Create new visit</h3>

        <form onSubmit={handleSubmit}>
          <div className="flex flex-col md:flex-row md:space-x-4">
            <div className="mb-4 w-full">
              <label className="block text-sm font-medium">Customer name</label>
              <input
                type="text"
                className="w-full p-2 border rounded-md"
                value={customerName}
                onChange={(e) => setcustomerName(e.target.value)}
              />
            </div>

            <div className="mb-4 w-full">
              <label className="block text-sm font-medium">Visit date</label>
              <input
                type="date"
                className="w-full p-2 border rounded-md"
                value={visitDate}
                onChange={(e) => setVisitDate(e.target.value)}
              />
            </div>
          </div>

          <div className="flex flex-col md:flex-row md:space-x-4">
            <div className="mb-4 w-full">
              <label className="block text-sm font-medium">Visit Outcome</label>
              <select
                className="w-full p-2 border rounded-md"
                value={visitOutcome}
                onChange={(e) => setVisitOutcome(e.target.value)}
              >
                <option value="Successful">Successful</option>
                <option value="Unsuccessful">Unsuccessful</option>
              </select>
            </div>

            <div className="mb-4 w-full">
              <label className="block text-sm font-medium">Comment</label>
              <input
                type="text"
                className="w-full p-2 border rounded-md"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                placeholder="Enter comment"
              />
            </div>
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium">Strike rate</label>
            <input
              type="number"
              className="w-full p-2 border rounded-md"
              value={strikeRate}
              onChange={(e) => setStrikeRate(e.target.value)}
              placeholder="Enter strike rate"
            />
          </div>

          <div className="flex justify-end space-x-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 border border-blue-500 text-blue-500 rounded-md"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-500 text-white rounded-md"
            >
              Submit feedback
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FeedbackLogTable;
